"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
var kotlin_map_factory_1 = require("../../util/kotlin-map-factory");
/******************************************** LOGGING *********************************************/
var util_1 = require("util");
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('diseases.ts', shared_1.Styles.bracelet, util_1.inspect);
/************************************ BUILD INSTANTIATED DATA *************************************/
/**
 * Disease object factory
 */
var buildDisease = function (diseaseJson) {
    return new javelin_exports_1.Disease(diseaseJson.diseaseId, diseaseJson.conceptId, kotlin_map_factory_1.dirtyKotlinMap(diseaseJson.preferredTerms), kotlin_map_factory_1.dirtyKotlinMap(diseaseJson.descriptions), diseaseJson.faqs, diseaseJson.travel);
};
/**
 * Prepare disease data for use by mixing the corresponding FAQ data into each disease
 */
var prepDiseaseData = function (data) {
    var diseases = data.diseases, faqs = data.faqs;
    // Ensure all disease items have a faqs prop
    diseases.forEach(function (disease) { return (disease.faqs = []); });
    // Add FAQ items to faqs on the corresponding disease
    faqs.forEach(function (faq) {
        var curFAQ = new javelin_exports_1.FAQ(faq.faqId.toString(), faq.diseaseId, "disease", kotlin_map_factory_1.dirtyKotlinMap(faq.questions), kotlin_map_factory_1.dirtyKotlinMap(faq.answers), faq.index);
        for (var _i = 0, diseases_1 = diseases; _i < diseases_1.length; _i++) {
            var disease = diseases_1[_i];
            if (disease.diseaseId === faq.diseaseId) {
                disease.faqs.push(curFAQ);
                break;
            }
        }
    });
    return diseases;
};
/****************************************** DATA EXPORT *******************************************/
/**
 * Build & export array of Disease objects
 * Defaults to grabbing from json file (diseases.json)
 *
 * TODO remove JSON file default source for Disease objects
 */
exports.diseases = function (data) {
    var diseaseData = prepDiseaseData(data);
    var diseaseDataOut = diseaseData.map(buildDisease);
    log.verbose("diseases:", util_1.inspect(diseaseDataOut, false, 10, true));
    return diseaseDataOut;
};
//# sourceMappingURL=diseases.js.map